import {
  Container,
  LinearProgress,
  ThemeProvider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { lazy, Suspense, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Footer from "./components/Footer";
import Header from "./components/Header/Header";
import { useGetFrontendBoot, useGetSellerInfo } from "./services";
import { Actions } from "./slices/actions";
const ComparePage = lazy(() => import("./pages/ComparePage/ComparePage"));
const MobileCompare = lazy(() => import("./pages/ComparePage/MobileCompare"));
const InputPage = lazy(() => import("./pages/InputPage/InputPage"));
const KnowMorePage = lazy(() => import("./pages/KnowMorePage"));
const ProposalPage = lazy(() => import("./pages/ProposalPage/ProposalPage"));
const QuotesPage = lazy(() => import("./pages/QuotesPage/QuotesPage"));
const ShortListedQuotePage = lazy(() =>
  import("./pages/ShortlistedQuotePage/ShortlistedQuotePage")
);
const ThankYouPage = lazy(() => import("./pages/ThankYouPage/ThankYouPage"));

function App() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { isFrontendBootLoading, settings, frontendBoot } =
    useGetFrontendBoot();
  const { userData } = useGetSellerInfo();
  Actions.setLeadData(userData);
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--primary-color",
      settings?.primary_color?.trim()
    );
    document.documentElement.style.setProperty(
      "--secondary-color",
      settings?.secondary_color?.trim()
    );
    document.documentElement.style.setProperty(
      "--primary-shade",
      settings?.primary_shade?.trim()
    );
    document.documentElement.style.setProperty(
      "--secondary-shade",
      settings?.secondary_shade?.trim()
    );
    document.documentElement.style.setProperty(
      "--primary-font",
      process.env.REACT_APP_FONT_FACE
    );
  }, [settings]);

  if (isFrontendBootLoading) {
    return (
      <Container
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LinearProgress />
      </Container>
    );
  }
  if (!settings) return null;
  const Layout = ({ children }) => {
    const { pathname: path } = useLocation();
    return (
      <>
        {!["*"].includes(path) && <Header userData={userData} />}
        <main>{children}</main>
        {!["*"].includes(path) && (
          <Footer tenant={frontendBoot?.traveltenant} />
        )}
      </>
    );
  };
  return (
    <>
      <ThemeProvider theme={theme}>
        <Suspense
          fallback={
            <Container
              sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LinearProgress />
            </Container>
          }
        >
          <Layout>
            <Routes>
              <Route path="/" element={<InputPage userData={userData} />} />
              <Route path="/quote" element={<QuotesPage />} />
              <Route path="/know-more" element={<KnowMorePage />} />
              <Route
                path="/compare"
                element={isMobile ? <MobileCompare /> : <ComparePage />}
              />
              <Route
                path="/shortlisted-quotes"
                element={<ShortListedQuotePage />}
              />
              <Route path="/proposal" element={<ProposalPage />} />
              <Route
                path="/thank-you"
                element={<ThankYouPage tenant={frontendBoot?.traveltenant} />}
              />
              <Route path="*" element={<></>} />
            </Routes>
          </Layout>
        </Suspense>
        <ToastContainer
          position="top-right"
          hideProgressBar
          autoClose={3000}
          limit={1}
        />
      </ThemeProvider>
    </>
  );
}

export default App;
